// extracted by mini-css-extract-plugin
export default {"meme":"FinalMessage_meme__jvdRD"};